(function () {

    "use strict";

    angular
        .module('blocks.modal')
        .service('obtModalService', obtModalService);

        obtModalService.$inject=['$rootScope','$uibModal','$state'];
    /*@ngInject*/
    function obtModalService($rootScope, $uibModal, $state){
        return {
            openModal:openModal
        };

        function openModal(args){
            args.callbackSuccess = args.callbackSuccess ? args.callbackSuccess :  angular.noop;
            args.callbackFailed = args.callbackFailed ? args.callbackFailed: angular.noop;
            args.size = args.size ? args.size : '';/* '' vs 'sm' vs 'lg'*/
            args.notLinkedToState = args.notLinkedToState ?  args.notLinkedToState : false;
            args.backdrop = (typeof args.backdrop === 'boolean' ?  args.backdrop : true);
            args.windowClass = args.windowClass ?  args.windowClass : 'right fade';

            var modalInstance = $uibModal.open(args);

            modalInstance.result.then(args.callbackSuccess,args.callbackFailed);
            if(! args.notLinkedToState){
                registerExistStateEvent(modalInstance);
            }
            return modalInstance;
        }

        function registerExistStateEvent(modalInstance){
            /* register to find when the current state is leaved */
            var currentState = $state.current.name ;/* returns the current*/
            var listener = $rootScope.$on('$stateChangeStart',
                function(event, toState, toParams, fromState, fromParams){
                    if(fromState.name === currentState){
                        /*close modal*/
                        modalInstance.dismiss('State leaved');
                        listener();
                    }
                });
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/modal/obt-modal.service.js
 ** module id = 88
 ** module chunks = 0
 **/